
define('text!plugins/password/setupTemplate.html',[],function () { return '';});

